import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
// import core firebase client (required)
import { of } from 'rxjs';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { Student } from '../tiposFormulario/student';
import { AutorizacionImagenes } from './../tiposFormulario/documents/autorizacion-imagenes';
import { RecogidaMenores } from './../tiposFormulario/documents/recogida-menores';



@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html'
})
export class DocumentsComponent extends BaseComponent  implements OnInit {

  @Input()
  public user;
  public userAuth;


  public tempIndex = 0;
  public student = new Student();
  public currentMonth;
  public cargando = false;

  @Input()
  public projects: any[];

  @Output()
  public propagar = new EventEmitter<string>();

  public recogidaMenores = new RecogidaMenores();
  public authImagenes = new AutorizacionImagenes();

  // {autRecogida: true, autImagenes: true, autWhatsapp: true};

  public documentsType = [{tipo: 'Contrato', state: 'contrato', name: 'contrato', instancia: null, estado: false, title: ''},
   {tipo: 'LOPD Imágenes', name: 'imagenes', state: 'autImagenes', instancia: this.authImagenes, estado: false, title: 'Autorización cesión de imágenes'},
   {tipo: 'LOPD Whatsapp', name: 'whatsapp', state: 'autWhatsapp', instancia: null, estado: false, title: 'Autorización mensajes de whatsapp'},
   {tipo: 'Recogida menores', name: 'recogidaMenores', state: 'autRecogida', instancia: this.recogidaMenores, estado: false,
    title: 'Autorización recogida del centro de menores'}];


  form: FormGroup;

  public readonly chevronLeft = faChevronLeft;
  public readonly chevronRight = faChevronRight;

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private router: Router,
              private firestore: AngularFirestore,
              private messageService: MessagesService,
              private fb: FormBuilder,
              private cdRef: ChangeDetectorRef) {

      super();
  }

  ngOnInit(): void {
    this.courseCurrent = this.students[this.studentCurrent].courseInfoArr[0];
    console.log('el user en documentos es ', this.user);
    console.log('los estudiantes son ', this.students);
    this.form = this.fb.group({
      docType: [undefined]
    });
  }

  sendDocumentSigned(item: any): void {
    item.currentStudent = this.studentCurrent;
    item.currentCourse = this.courseCurrent;
    this.propagar.emit(item);
  }

  async autorizarDocumento(item: any): Promise<any> {
      item.currentStudent = this.studentCurrent;
      item.currentCourse = this.courseCurrent;
      if (item.name === 'recogidaMenores') {
        this.cargando = true;
        const formBuilt: any[] = item.instancia.createFormulario();
        for (const form of formBuilt) {
          if (form.element === 'select' && form.reference) {
            const collection = await this.firestore.collection(form.reference).get().toPromise();
            collection.forEach(value => {
              let valueRef = value.id;
              if (form.referenceValue !== 'id') {
                valueRef = value.data()[form.referenceValue];
              }
              form.options.push({value: valueRef, key: value.data()});
            });
          }
        }

        const functionToExecute = (formGroup: FormGroup, form: any[], id: string) => {
          return of(formGroup).toPromise();
        };

        console.log('el formulario después es ', formBuilt);
        this.cargando = false;
        this.messageService.showFormInDialog(formBuilt, item.title, 'DOCUMENTO', functionToExecute).afterClosed()
          .subscribe(x => {
            if (x !== true) {
              console.log('la respuesta fue', x);
              item.value = {};
              Object.getOwnPropertyNames(x.object.value)
                .forEach(tag => {
                  item.value[tag] = x.object.value[tag];
                });
              this.propagar.emit(item);
            }
          });
    } else {
      this.propagar.emit(item);
    }
  }

  addNewDocument(): void {
    console.log(this.form.value);
    this.messageService.showFormInDialog([{ ...this.form.value }], 'Autorización recogida del centro de menores', 'DOCUMENTO', null);
  }

  showEnviado(item: any): boolean{
    // console.log(item);
    const studentId: string = this.students[this.studentCurrent].id;
    const name = (item.state === 'contrato') ? `contrato_${this.courseCurrent.id}` :
    (item.state === 'autRecogida') ? `autRecogida_${this.courseCurrent.id}` : item.state;
    return (this.user.alumnosAut && this.user.alumnosAut[studentId] && this.user.alumnosAut[studentId][name]);
  }
}
